<script setup>
import GuestLayout from '@/Layouts/GuestLayout.vue';
import { useForm } from '@inertiajs/vue3';

const form = useForm({
    username: '',
    password: '',
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => {
            form.reset('password');
        },
    });
};
</script>
<template>
    <GuestLayout title="Log in">
        <v-row justify="center">
            <v-col
                cols="12"
                sm="8"
                md="6"
                lg="4"
                class="d-flex flex-column align-center ga-2"
            >
                <h4 class="py-2">
                    Log In
                </h4>
                <v-form
                    class="w-100"
                    @submit.prevent="submit"
                >
                    <v-text-field
                        v-model="form.username"
                        label="Username *"
                        :error-messages="form.errors.username"
                    />
                    <v-text-field
                        v-model="form.password"
                        label="Password *"
                        type="password"
                        :error-messages="form.errors.password"
                    />
                    <v-btn
                        type="submit"
                        block
                        :loading="form.processing"
                        append-icon="far fa-right-from-bracket"
                    >
                        Log In
                    </v-btn>
                    <div class="d-flex justify-center mt-4">
                        <v-btn
                            :href="route('password.forgot')"
                            variant="text"
                            size="small"
                        >
                            Forgotten your password?
                        </v-btn>
                    </div>
                </v-form>
            </v-col>
        </v-row>
    </GuestLayout>
</template>
